import React from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import Button from "../../common/button/button";

export function ModalSelecionarModoPrevisorCustos(props) {
    return (
        <ModalAlert titulo={props.titulo || "Previsor de Custos"} handleClose={props.handleClose} maxWidth={560}>
            <div style={{ display: "flex", flexDirection: "column", rowGap: 16 }}>
                <div style={{ color: "#333" }}>{props.mensagem}</div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button style={{ margin: 0 }} text="Ok" type="primary" event={props.handleClose} />
                </div>
            </div>
        </ModalAlert>
    );
}
